import { render, staticRenderFns } from "./PromoRedeemEvent.vue?vue&type=template&id=77d180a3"
import script from "./PromoRedeemEvent.vue?vue&type=script&lang=js"
export * from "./PromoRedeemEvent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports